import { render, staticRenderFns } from "./CampaignsScreen.vue?vue&type=template&id=58f151fc&scoped=true"
import script from "./CampaignsScreen.vue?vue&type=script&lang=js"
export * from "./CampaignsScreen.vue?vue&type=script&lang=js"
import style0 from "./CampaignsScreen.vue?vue&type=style&index=0&id=58f151fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f151fc",
  null
  
)

export default component.exports